import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import CardsTab from './CardsTab';
import BoardTab from './BoardTab';
import { CARDS_TAB_ID, BOARD_TAB_ID } from '../../constants';
import { useHasCardsV2 } from '../hooks/useHasCardsV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditBoardViewTabs = ({
  defaultTabId = CARDS_TAB_ID
}) => {
  const hasCardsV2 = useHasCardsV2();
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: hasCardsV2 ? BOARD_TAB_ID : defaultTabId,
    children: [hasCardsV2 ? null : /*#__PURE__*/_jsx(Tab, {
      tabId: CARDS_TAB_ID,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.tabs.cards"
      }),
      children: /*#__PURE__*/_jsx(CardsTab, {})
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: BOARD_TAB_ID,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.tabs.board"
      }),
      children: /*#__PURE__*/_jsx(BoardTab, {})
    })]
  });
};
export default EditBoardViewTabs;